const UAParser = require('ua-parser-js');

function getAttributes() {
    // eslint-disable-next-line no-undef
    const userAgent = window && window.navigator ? window.navigator.userAgent : '';
    const parser = new UAParser.UAParser(userAgent);
    const userAgentParsed = parser.getResult();
    if (!userAgentParsed) {
        return {};
    }

    const device = mapDevice(
        userAgentParsed.os.name,
        userAgentParsed.device.type
    );
    const browserId = mapBrowser(userAgentParsed.browser.name);

    return {
        browserId,
        device,
    };
}

function mapBrowser(input) {
    switch (input) {
        case 'Chrome':
            return 'gc';

        case 'Firefox':
            return 'ff';

        case 'Mobile Safari':
        case 'Safari':
            return 'safari';

        case 'Edge':
            return 'edge';

        case 'IE':
            return 'ie';
        default:
            return 'unknown';
    }
}

function mapDevice(os, device) {
    if (!device) {
        switch (os) {
            case 'Windows':
            case 'Mac Os':
            case 'Mac OS':
            case 'Ubuntu':
                return 'desktop';

            default:
                return 'unknown';
        }
    } else if (os === 'iOS') {
        switch (device) {
            case 'tablet':
                return 'ipad';
            case 'mobile':
                return 'iphone';
            default:
                return device;
        }
    } else {
        return device;
    }
}

module.exports = { getAttributes };
